import axios from 'axios'
import React, { useEffect, useState } from 'react'

const Ploginpage = () => {
    const [user,setuser]=useState("")
    const [Firstname,setName]=useState("")
    const [secondname,setSecondname]=useState("")
    const [useremail,setEmail]=useState("")
    const [password,setPassword]=useState("")
    const[phone,setPhone]=useState("")

    

  
  
  
  const loginuser  = async(e)=>{
   e. preventDefault();
  
     
    const data =new FormData()
    data.append('email',useremail)
    data.append('password',password)
    data.append('phone_number',phone)
    data.append('first_name',Firstname)
    data.append('last_name',secondname)
       
    const response = await axios .post ("https://amazon.indianhackerslab.com/signup.php" ,data,{"header" : {"content-type": "multipart/formdata" }} ) 
     if (response) {
     
      if(response.data.status==="success"){
        console.log(response.data)
        console.log(response.data.data)
        window.location.replace("/page")
      }


    // localStorage.setItem("user2",JSON.stringify( response.data.data))

      

   
    
    
     }        
  
  }
  
 
  



      
  return (


    <div>
      <div className='col-3 mx-auto p-3'>

      {/* <h2> localStorage : {localStorage.getItem('user2')}</h2> */}
      
    

      <form onSubmit={loginuser}  >
    <input   onChange={ (event)=>setName(event.target.value)} placeholder='username'></input>
   <input   onChange={(event)=>setSecondname(event.target.value)} placeholder='user secondname'></input>
   <input   onChange={(event)=>setEmail(event.target.value)} placeholder='email'></input>
   <input   onChange={(event)=>setPassword(event.target.value)} placeholder='password'></input>
   <input  onChange={(event)=>setPhone(event.target.value)} placeholder='phone'></input>
  
   <button>login</button>

 
    </form>

     <div>
       {

       }
     </div>

      </div>

    </div>
  )
}

export default Ploginpage